import React, { useRef } from "react";
import "./Searchbar.css";
import img_search from "../../../img_4/search_1.png";
import img_close from "../../../img_4/close.png";

export default function Searchbar({ searflag, setSearch }) {
  const searchRef = useRef();

  const goKeyCodeSearch = (e) => {
    let keycode = e.keyCode;
    if (keycode === 13 && searchRef.current.value !== "") {
      window.location = "/page/search?words=" + searchRef.current.value;
    }
  };

  const goSearch = (e) => {
    if (searchRef.current.value !== "") {
      window.location = "/page/search?words=" + searchRef.current.value;
    }
  };

  const dis_none = () => {
    setSearch();
  };

  return (
    <div className={searflag ? "searchbar4 searchbar_dis" : "searchbar4"}>
      <img src="" alt="" />
      <div className="search_box">
        <input
          type="search"
          onKeyUp={goKeyCodeSearch}
          placeholder="search"
          ref={searchRef}
        />
        <img src={img_search} alt="" onClick={goSearch} />
      </div>
      <img src={img_close} alt="" className="sear_c" onClick={dis_none} />
    </div>
  );
}
